
import Vue from 'vue';
import { mapState } from 'vuex';

export default Vue.extend({
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    computed: {
        ...mapState("ui", ["isMobileViewDisplayed"])
    },

    methods: {
        onBannerClick(banner: any) {
            if(banner.bannerInfo.bannerActionType == 1) {
                this.$router.push({
                    name: "productsPageByCampaign",
                    params: {
                        campaignId: banner.id,
                        campaignName: banner.campaignInfo.name,
                        campaignCollectionType: banner.itemsCollectionType,
                        title: banner.campaignInfo.name,
                    },
                    
                    query: {
                        type: banner.itemsCollectionType,
                        typeId: banner.itemsCollectionId,
                    }

                });
            }

            else if(banner.bannerInfo.bannerActionType == 3){
                var anchor = document.createElement('a');
                anchor.href = banner.bannerInfo.onClickGoToURL;
                anchor.target="_blank"
                anchor.click();
                anchor.remove();
            }

        },
    }
});
